import ApiService from "src/shared/utils/base-api/api-service";
import { ResponseDto } from "src/shared/common-dtos/response-dto";
import { ParamsDto } from "src/shared/common-dtos/params-dto";

import {
  CreateOrUpdatePriceBracketDto,
  PriceBracketDto,
  UpdatePriceBracketCountriesDto,
} from "./dto";

class PriceBracketsService extends ApiService {
  constructor() {
    super({
      baseURL: "/PriceBracket",
    });
  }
  public getAllPriceBrackets(
    input?: ParamsDto,
  ): Promise<ResponseDto<PriceBracketDto[]>> {
    return this.get("", {
      params: input,
    });
  }

  public getPriceBracket(id: string): Promise<ResponseDto<PriceBracketDto>> {
    return this.get(`/${id}`);
  }

  public createPriceBracket(
    priceBracket: CreateOrUpdatePriceBracketDto,
  ): Promise<ResponseDto<PriceBracketDto>> {
    return this.post("", priceBracket);
  }
  public updatePriceBracket(
    priceBracket: CreateOrUpdatePriceBracketDto,
  ): Promise<ResponseDto<PriceBracketDto>> {
    return this.put(`${priceBracket.id}`, priceBracket);
  }

  public updatePriceBracketCountries(
    params: UpdatePriceBracketCountriesDto,
  ): Promise<ResponseDto<PriceBracketDto>> {
    return this.put(`/${params.id}/countries`, params);
  }

  public deletePriceBracket(id: string): Promise<ResponseDto<null>> {
    return this.delete(`/${id}`);
  }
}

export const priceBracketService = new PriceBracketsService();
